export interface Currency {
  code: string;
  symbol: string;
  nameKey: string;
  locale: string;
}

export const currencies: Currency[] = [
  { code: 'KZT', symbol: '₸', nameKey: 'currencies.KZT', locale: 'kk-KZ' },
  { code: 'RUB', symbol: '₽', nameKey: 'currencies.RUB', locale: 'ru-RU' },
  { code: 'USD', symbol: '$', nameKey: 'currencies.USD', locale: 'en-US' },
  { code: 'EUR', symbol: '€', nameKey: 'currencies.EUR', locale: 'de-DE' },
  { code: 'GBP', symbol: '£', nameKey: 'currencies.GBP', locale: 'en-GB' },
  { code: 'CNY', symbol: '¥', nameKey: 'currencies.CNY', locale: 'zh-CN' },
  { code: 'TRY', symbol: '₺', nameKey: 'currencies.TRY', locale: 'tr-TR' },
  { code: 'UAH', symbol: '₴', nameKey: 'currencies.UAH', locale: 'uk-UA' },
  { code: 'BYN', symbol: 'Br', nameKey: 'currencies.BYN', locale: 'be-BY' },
  { code: 'UZS', symbol: 'сўм', nameKey: 'currencies.UZS', locale: 'uz-UZ' },
  { code: 'GEL', symbol: '₾', nameKey: 'currencies.GEL', locale: 'ka-GE' },
  { code: 'AED', symbol: 'د.إ', nameKey: 'currencies.AED', locale: 'ar-AE' },
];

export function getCurrencyByCode(code: string): Currency {
  return currencies.find(c => c.code === code) || currencies[0];
}

export function formatCurrency(amount: number, currencyCode: string = 'KZT'): string {
  const currency = getCurrencyByCode(currencyCode);
  const formatted = new Intl.NumberFormat(currency.locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
  
  return `${formatted} ${currency.symbol}`;
}
